import styled from "styled-components/macro"

const Favourites = ({ children }) => {
  return <FavouritesWrapper>{children}</FavouritesWrapper>
}

const FavouritesWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  height: 100%;
  width: 100%;
  background-color: #0e2620;

  .favourites-container {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .no-favourites {
      font-size: 2em;
      font-weight: 700;
      color: var(--primary);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      line-height: 0.5em;

      span {
        width: 100%;
        display: inline-block;
        color: #50a49c;
        font-family: SecondaryFont;
      }
    }

    .switch {
      button {
        all: unset;
      }

      .SwitchRoot {
        width: 40px;
        height: 22px;
        background-color: var(--secondary);
        border-radius: 9999px;
        position: relative;
        -webkit-tap-highlight-color: transparent;

        &[data-state="checked"] {
          background-color: var(--primary);
        }
      }

      .SwitchThumb {
        display: block;
        width: 19px;
        height: 15px;
        background-color: white;
        border-radius: 9999px;
        transition: transform 100ms;
        transform: translateX(4px);
        will-change: transform;

        &[data-state="checked"] {
          transform: translateX(17px);
        }
      }

      .Label {
        color: white;
        font-size: 10px;
        letter-spacing: 1px;
        line-height: 1;
      }
    }

    .favourites-table {
      width: 50%;
      height: 100%;
      transition: all 0.3s ease;
      display: flex;
      flex-direction: column;
      gap: 2em;
      justify-content: flex-end;
      align-items: center;
      padding: 4em;
      font-weight: 700;
      background-color: rgba(127, 144, 137, 0.96);

      .title-fav{
        height: 15%;
        max-height: 15%;
        width: 105%;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        transform: translateY(calc(15px + 3em));
        font-style: italic;

        & h1{
          color: var(--accent);
          font-size: 7rem;
          line-height: 6.5rem;
        }
        & h2{
          color: var(--black);
          font-size: 4rem;
          line-height: 4rem;
        }
      }

      .table {
        width: 105%;
        height: 45%;
        max-height: 50%;
        border-radius: 2rem;
      }

      .switch {
        margin-left: auto;
      }

      .flex-table-header {
        color: var(--accent);
      }

      #table-rows-container {
        overflow-y: scroll;
      }

      .favourites-control-index {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        gap: 1rem;

        .buttons {
          height: 3em;
          border-radius: 2rem;
          color: var(--black);
          background-color: rgba(255, 255, 255, 0.2);
          cursor: pointer;
          flex: 1;
          transition: all 0.3s ease;

          &.active {
            background-color: var(--accent);
          }
        }
      }

      .table-bottom-controls {
        display: flex;
        width: 100%;
        margin-top: 1em;
        gap: 1em;
        height: 3em;

        .clear-favorites {
          display: flex;
          gap: 1em;

          .prompt {
            display: flex;
            gap: 1em;
            margin-left: -2em;
            opacity: 0;
            transition: all 0.3s ease-in-out;

            &.active {
              opacity: 1;
              margin-left: 0em;
              transition: all 0.3s ease-in-out;
            }
          }
        }
      }
    }

    .favourites-info {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      background-color: white;

      .unit-compare-container {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .unit-top {
          border-bottom: 2px solid #fff;
          width: 100%;
          height: 50%;
        }
        .unit-bottom {
          width: 100%;
          height: 50%;
        }
      }
    }

    .unit-single-container {
      height: 100%;
      width: 100%;
      
      .unit-single {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;
        height: 100%;
        max-height: 100%;

        .info-card-container,
        .image-display-container {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .info-card-container {
          height: 40%;
        }
        .image-display-container {
          height: 50%;
        }
      }

      .single-unit-controls{
        position: relative;
        height: 8%;
        width: 100%;
        display: flex;
        align-items: center;
        padding: 1em 6em;
        justify-content: space-between;

        .enlarge-single{
          position: relative;
          inset: 0;
          border-radius: 100%;
        }
        .remove-single{
          position: relative;
          border-radius: 100%;
          inset: 0;
        }
      }
    }
  }
`

export default Favourites
